import React, { Component } from 'react'
import { Trans, withTranslation } from 'react-i18next'
import '../styles.scss'
import PropTypes from 'prop-types'
import Bars from '../../../../../../Shared/Bars'
import { constants } from '../../../../../../../constants'
import ProLabel from '../../../../../../Shared/ProLabel'
import {
  getDestinationScoresAvg,
  getDestinationScoresTop,
  getScores, getSuppliers, getTourOperators,
} from '../../../../../../../http/driveApiGateway/client'
import Row from '../../../../../../Shared/GridGM'
import Col from '../../../../../../Shared/GridGM/Col'
import Table from '../../../../../../Shared/Table'
import TableRow from '../../../../../../Shared/Table/TableRow'
import TableHead from '../../../../../../Shared/Table/TableHead'
import TableData from '../../../../../../Shared/Table/TableData'

// Todo: reuse single graph table // reduce code duplication
class DoubleGraphTable extends Component {
  constructor (props) {
    super(props)
    const { t } = this.props
    this.state = {
      rings: {
        values: [
          { deg: -1, value: false, label: t('LABEL_MY_HOTEL') },
          { deg: -1, value: false, label: t('LABEL_MY_AREA') + '*' },
          { deg: -1, value: false, label: t('LABEL_MY_WORLD') + '*' }
        ],
        sum: false,
        sum_subline: false
      },
      tableData: [],
      suppliers: {},
      tourOperators: {}
    }
  }

  componentDidMount () {
    this.updateData()
    this.setTableRows()
    window.addEventListener('resize', this.setTableRows.bind(this))
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.setTableRows.bind(this))
  }

  // noinspection JSCheckFunctionSignatures
  componentDidUpdate (prevProps, prevState) {
    const { t } = this.props
    if (this.props.activeHotel.id !== prevProps.activeHotel.id) {
      this.updateData()
    }
    if (this.props.widget.scoreId === 1 && this.state.suppliers !== prevState.suppliers) {
      const rings = Object.assign({}, this.state.rings)
      if (this.state.suppliers) {
        rings.sum_subline = this.state.suppliers.suppliersCount + ' ' + t(this.props.widget.mainValueLabel, { count: this.state.suppliers.suppliersCount })
      } else {
        rings.sum_subline = 0 + ' ' + t(this.props.widget.mainValueLabel, { count: 0 })
      }
      this.setState({
        rings
      })
    }
    if (this.props.widget.scoreId === 2 && this.state.tourOperators !== prevState.tourOperators) {
      const rings = Object.assign({}, this.state.rings)
      if (this.state.tourOperators) {
        rings.sum_subline = this.state.tourOperators.operators + ' ' + t(this.props.widget.mainValueLabel, { count: this.state.tourOperators.operators })
      } else {
        rings.sum_subline = 0 + ' ' + t(this.props.widget.mainValueLabel, { count: 0 })
      }
      this.setState({
        rings
      })
    }
  }

  setTableRows () {
    this.setState({
      show_table_rows: Math.floor(window.innerWidth / 300)
    })
  }

  setScoreData (scoresData, ringId) {
    if (scoresData.error === undefined) {
      this.setState((prevState) => {
        // noinspection JSUnresolvedReference
        const percentage = scoresData.scores[scoresData.scores.findIndex(s => s.id === this.props.widget.scoreId)].percentage
        const rings = Object.assign({}, prevState.rings)
        rings.values[ringId].deg = percentage * 270
        rings.values[ringId].value = Math.ceil(percentage * 100)
        return {
          ...prevState,
          rings
        }
      })
    }
  }

  updateData () {
    let giataId = this.props.activeHotel.attr[constants.attributePaths.giataId][1].data.code
    getScores(giataId).fetchPromise.then((scoresData) => {
      this.setScoreData(scoresData, 0)
      let scores = scoresData.scores[scoresData.scores.findIndex(s => s.id === this.props.widget.scoreId)]
      const rings = Object.assign({}, this.state.rings)
      // noinspection JSUnresolvedReference
      rings.sum = Math.ceil(scores.percentage * 100) + '%'
      this.setState({
        rings
      })
    })
    getDestinationScoresAvg(this.props.activeHotel.attr[constants.attributePaths.destination][1].data.href)
      .fetchPromise.then((scoresData) => {
      this.setScoreData(scoresData, 1)
    })
    getDestinationScoresTop(this.props.activeHotel.attr[constants.attributePaths.destination][1].data.href, this.props.widget.scoreId)
      .fetchPromise.then((scoresData) => {
      this.setScoreData(scoresData, 2)
    })
    if (this.props.widget.scoreId === 1) {
      getSuppliers(giataId).fetchPromise.then((suppliers) => {
        this.setState({ suppliers })
      })
    }
    if (this.props.widget.scoreId === 2) {
      getTourOperators(giataId).fetchPromise.then((tourOperators) => {
        this.setState({ tourOperators })
      })
    }
  }

  render () {
    return (
      <div className="Widget Widget-Graph Widget-Double">
        <div className="Widget-Content">
          <h3><Trans>{this.props.widget.title}</Trans></h3>
          {constants.scores.types[this.props.widget.scoreId].pro &&
            <ProLabel/>
          }
          <small className="Widget-ScoresHint"><span>*</span> Hotels in your destination</small>
          <Row gap="large">
            <Col cols="6">
              <Bars className={'Bars-score-' + this.props.widget.scoreId} values={this.state.rings}></Bars>
            </Col>
            <Col cols="6">
              {(this.props.widget.scoreId === 2
                  && this.state.tourOperators
                  && this.state.tourOperators.hasOwnProperty('tourOperators')) &&
                <Table>
                  <TableRow>
                    <TableHead><Trans>TABLE_HEAD_TOUR_OPERATORS</Trans></TableHead>
                  </TableRow>
                  {this.state.tourOperators.tourOperators.map((operator, index) => {
                    if (index < this.state.show_table_rows) {
                      return (
                        <TableRow key={index}>
                          <TableData>{operator.name}</TableData>
                        </TableRow>
                      )
                    } else if (index === this.state.show_table_rows) {
                      return (
                        <TableRow key={index}>
                          <TableData>{(this.state.tourOperators.tourOperators.length - this.state.show_table_rows)} more</TableData>
                        </TableRow>
                      )
                    } else {
                      return null
                    }
                  })}
                </Table>
              }
              {(this.props.widget.scoreId === 1
                  && this.state.suppliers
                  && this.state.suppliers.hasOwnProperty('suppliers')) &&
                <Table>
                  <TableRow>
                    <TableHead><Trans>TABLE_HEAD_SUPPLIERS</Trans></TableHead>
                  </TableRow>
                  {this.state.suppliers.suppliers.map((supplier, index) => {
                    if (index < this.state.show_table_rows) {
                      return (
                        <TableRow key={index}>
                          <TableData>{supplier.name}</TableData>
                        </TableRow>
                      )
                    } else if (index === this.state.show_table_rows) {
                      return (
                        <TableRow key={index}>
                          <TableData>{(this.state.suppliers.suppliers.length - this.state.show_table_rows)} &nbsp;
                            <Trans>TABLE_MORE</Trans></TableData>
                        </TableRow>
                      )
                    } else {
                      return null
                    }
                  })}
                </Table>
              }
            </Col>
          </Row>
        </div>
      </div>
    )
  }
}

DoubleGraphTable.defaultProps = {}
DoubleGraphTable.propTypes = {
  activeHotel: PropTypes.object.isRequired,
  widget: PropTypes.shape({
    scoreId: PropTypes.number.isRequired,
    mainValueLabel: PropTypes.string.isRequired
  }).isRequired
}
export default withTranslation()(DoubleGraphTable)
